import { setUnauthorizedHandler } from "@/lib/api/client";

import { authApi } from "./auth-api";
import { createAuthStore, SESSION_STORAGE_KEY } from "./auth-store";

/** Storage can be missing or throw on access (private mode, blocked site data). */
function storageOrNull(pick: () => Storage): Storage | null {
  try {
    return pick();
  } catch {
    return null;
  }
}

function sessionTtlMs(): number {
  const hours = Number(import.meta.env.VITE_ADMIN_SESSION_TTL_HOURS ?? 8);
  return (Number.isFinite(hours) && hours > 0 ? hours : 8) * 3_600_000;
}

/** The dashboard's one auth store; see auth-store.ts. */
export const authStore = createAuthStore({
  api: authApi,
  persistent: storageOrNull(() => window.localStorage),
  temporary: storageOrNull(() => window.sessionStorage),
  sessionTtlMs: sessionTtlMs(),
  verifyWithServer: true,
});

// Any API call answered with 401 means the cookie is gone: sign out here too.
setUnauthorizedHandler(() => authStore.expire());

// Signing in or out in another tab (with "keep me signed in") applies to this one too.
window.addEventListener("storage", (event) => {
  if (event.key === SESSION_STORAGE_KEY || event.key === null) authStore.syncFromStorage();
});
